export const MIN_VISIBLE_CARDS = 3
export const CARDS_STORAGE_VERSION = 1
export const CARDS_STORAGE_KEY = 'vtexads:rm:campaign-view-cards'
